const KEYCODES = {
  ESCAPE: 27
};

export default KEYCODES;
